module.exports = __webpack_public_path__ + "static/img/logo.f047455.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 11